<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/course/index">我的课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ courseInfo.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="small" class="reback" type="primary" icon="el-icon-refresh-left" @click="back()">返回列表
      </el-button>
    </el-col>
    <div class="content">
      <div class="xcx-content flex" v-loading="loading">
        <div class="flex-grow bg-w">
          <div class="box-border pt25 pb25 border-b-s flex text-default">
            <div class="mr20" style="width: 150px;">
              <img class="thumb_images" :src="courseInfo.thumb" alt="">
            </div>
            <div class="x">
              <div class="mb10">
                <span class="text-default ft26">{{ courseInfo.title }}</span>
                <div class="inline-block ml10 border border-solid bdr6 ft18 pd5">
                  {{ courseInfo.total }}课时</div>
              </div>
              <div class="flex mb40">
                <div class="ft14 text-tags pl10 pr10 pd5 bdr4 border-tags mr10">
                  {{ courseInfo.pattern_name }}</div>
                <div class="ft14 text-6581A0 pl10 pr10 pd5 bdr4 border-sub mr10">
                  {{ courseInfo.subject_name }}</div>
              </div>
              <div class="flex">
                <img class="wh48 rounded-full mr15" :src="teacherInfo.thumb" alt="">
                <div class="">
                  <h4 class="text-default ft16 mb10">主讲老师：{{ teacherInfo.title }}</h4>
                  <p class="text-info-light ft14">老师介绍：{{ teacherInfo.speaker }}</p>
                </div>
              </div>
            </div>
            <el-button style="position: absolute;top: 160px;right: 40px;z-index: 1;" class="reback" type="danger"
              icon="el-icon-download" @click="courseDownload(courseInfo.id)">随堂资料下载
            </el-button>
          </div>

          <div class="pt20 pb20">
            <el-empty :image-size="200" v-if="chapterlist.length == 0" description="暂未上传课程，请耐心等待上传……"></el-empty>
            <div v-else>
              <div class="flex mb20">
                <div class="year-tag" :class="{ active: currentYear === n.years }" v-for="(n, index) in chapterlist"
                  :key="index" @click="changeYear(index)">{{ n.years
                  }}年
                </div>
              </div>
              <div class="xx">
                <div v-for="(itemName, idx) in videoList" :key="idx">
                  <div class="nav_title" @click="toSelectedTeacher(idx)">
                    <div class="bigTitle">
                      <img src="../../../public/images/jian.png" v-if="idx == teacher" />
                      <img src="../../../public/images/jia.png" v-else />
                      {{ idx }}
                    </div>
                    <div class="bigTotal">共{{ itemName.length }}节</div>
                  </div>
                  <div class="bg-F9F9F9 flex space alcenter box-border pl10 pr10 mb10" v-for="(v, i) in itemName"
                    :key="i" v-if="idx == teacher">
                    <div class="flex-grow flex text-6F8199 ft14 text-over">
                      <!-- <div class="mr20">第{{ i + 1 }}节</div> -->
                      <div v-if="v.type == 1" class="live">直播课</div>
                      <div class="truncate" :title="v.title">{{ v.title }}</div>
                    </div>

                    <div v-if="v.type == 0" class="flex-shrink-0 text-6F8199 ft14 ml30">时长：{{ v.duration }}</div>
                    <div v-if="v.type == 0" class="flex-shrink-0 ml30">
                      <div class="text-6F8199 ft14">进度：</div>
                    </div>
                    <div v-if="v.type == 0" class="flex-shrink-0 col6 ft12">
                      <el-progress :text-inside="true" :stroke-width="16" :percentage="Math.floor(v.listen_rate)">
                      </el-progress>
                    </div>
                    <div v-if="v.type == 0" class="flex-shrink-0 ml30">
                      <el-button size="small" type="primary" @click="goCourseVideo(v)">开始学习</el-button>
                    </div>

                    <div v-if="v.type == 1" class="flex-shrink-0 ml30">
                      <el-button size="small" type="primary" :loading="openingLiveId === v.id" @click="goCourseVideo(v)" v-if="v.live_status == 0">{{
                        v.live_time
                      }} 开播</el-button>
                      <el-button size="small" type="primary" :loading="openingLiveId === v.id" @click="goCourseVideo(v)"
                        v-else-if="v.live_status == 1">观看直播</el-button>
                      <el-button size="small" type="primary" :loading="openingLiveId === v.id" @click="goCourseVideo(v)" v-else>观看回放</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: 0,
      currentYear: 0,
      courseInfo: [],
      chapterlist: [],
      video: "",
      videoList: [],
      teacherInfo: [],
      list: [],
      idx: 0,
      pack_id: 0,
      ids: 0,
      teacher: "",
      openingLiveId: 0,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
      that.getList();
    }
    if (query.pack_id) {
      that.pack_id = query.pack_id;
      that.ids = query.ids;
    }
  },
  methods: {

    toSelectedTeacher(name) {
      if (this.teacher && this.teacher == name) {
        name = "";
      }
      this.teacher = name;
    },
    sortGroupedVideos(groupedVideos) {
      return Object.keys(groupedVideos)
        .sort((a, b) => b.localeCompare(a, 'zh-CN'))
        .reduce((acc, key) => {
          acc[key] = groupedVideos[key];
          return acc;
        }, {});
    },

    changeYear(index) {
      var _this = this
      var yearItem = _this.list[index] || {};
      var video = yearItem.video || [];
      var teacher = "";
      if (video.length && teacher == '') {
        teacher = video[0]['teacher_name'];
      }
      const groupedByAge = video.reduce((acc, person, currentIndex) => {
        person.currentIndex = currentIndex;
        const age = person.teacher_name;
        if (!acc[age]) {
          acc[age] = [];
        }
        acc[age].push(person);
        return acc;
      }, {});

      this.videoList = this.sortGroupedVideos(groupedByAge);
      this.video = video;
      this.teacher = teacher;
      this.currentYear = yearItem.years || 0;
    },

    courseDownload(course_id) {
      this.$router.push({
        path: "/course/download",
        query: {
          course_id: course_id,
        },
      });
    },

    goCourseVideo(v) {
      if (!v) {
        return;
      }
      if (v.type == 0) {
        this.$router.push({
          path: "/course/player",
          query: {
            pack_id: this.pack_id,
            course_id: v.course_id,
            video_id: v.id,
            ids: this.ids,
            idx: this.idx,
          },
        });
      } else {
        this.openingLiveId = v.id;
        const target = {
          path: this.getLivePath(v),
          query: this.buildLiveQuery(v),
        };

        this.safeNavigate(target);
      }
    },
    safeNavigate(target) {
      const resolved = this.$router.resolve(target);
      return this.$router.push(target).catch((error) => {
        const isDuplicated = error && (error.name === 'NavigationDuplicated' || /Avoided redundant navigation/i.test(error.message || ''));
        if (!isDuplicated) {
          window.location.href = resolved.href;
        }
      }).then(() => {
        this.openingLiveId = 0;
      }, () => {
        this.openingLiveId = 0;
      });
    },
    getLivePath(v) {
      const provider = v.live_provider || v.live_platform || v.platform || v.provider || "";
      return String(provider).toLowerCase() === "bjy" || Number(v.is_bjy_live) === 1 ? "/course/bjy-live" : "/course/live";
    },
    buildLiveQuery(v) {
      const query = {
        pack_id: this.pack_id,
        course_id: v.course_id,
        video_id: v.id,
        ids: this.ids,
        idx: this.idx,
      };

      [
        'room_id',
        'roomId',
        'sign',
        'sdkBaseUrl',
        'sdk_base_url',
        'prefixName',
        'prefix_name',
        'privateDomainPrefix',
        'private_domain_prefix',
        'user_number',
        'userNumber',
        'user_name',
        'userName',
        'user_avatar',
        'userAvatar',
        'teacher_number',
        'teacherNumber',
        'teacher_name',
        'teacherName',
        'teacher_avatar',
        'teacherAvatar',
        'teacher_role',
        'teacherRole',
        'user_role',
        'userRole',
        'env',
        'webrtc',
        'live_provider',
        'live_platform',
        'provider',
        'platform',
        'is_bjy_live'
      ].forEach((key) => {
        if (v[key] !== undefined && v[key] !== null && v[key] !== '') {
          query[key] = v[key];
        }
      });

      return query;
    },
    /**
     * 获取列表
     */
    getDetail() {
      let that = this;
      that.axios.post("/getCourseDetails", { id: that.id }).then((res) => {
        if (res) {
          that.courseInfo = res.data;
          that.teacherInfo = res.data.teacher;
        }
      });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      that.axios.post("/getYtkCourseVideo", { id: that.id }).then((res) => {
        if (res) {
          that.chapterlist = res.data;
          if (res.data.length) {
            this.list = res.data;
            //that.videoList = res.data[0].video;
            //that.currentYear = res.data[0].years;
            var list = res.data;
            var video = list[0]['video'];
            var years = list[0]['years'];
            var teacher = "";

            list.forEach(function (element) {
              if (element.last_years == 1) {
                video = element.video;
                teacher = video[0]['teacher_name'];
                years = element.years;
              }
            });

            if (teacher == '') {
              teacher = video[0]['teacher_name'];
            }

            //判断用户上次听课是哪一节
            const groupedByAge = video.reduce((acc, person, currentIndex) => {
              person.currentIndex = currentIndex;
              const age = person.teacher_name;
              if (!acc[age]) {
                acc[age] = [];
              }
              acc[age].push(person);
              return acc;
            }, {});
            that.videoList = that.sortGroupedVideos(groupedByAge);
            that.video = video;
            that.currentYear = years;
            that.teacher = teacher;
          }
          that.loading = false;
        }
      });
    },
    back() {
      if (this.pack_id != 0) {
        this.$router.push({
          path: "/package/details",
          query: {
            id: this.ids,
            pack_id: this.pack_id,
          },
        });
      } else {
        this.$router.push("/course/index");
      }
    },
  },
};
</script>
<style>
.nav_title {
  width: 100%;
  margin: 5px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #f4f6f9;
  height: 42px;
  line-height: 42px;
  cursor: pointer;
}

.bigTitle {
  font-size: 15px;
  color: #272728;
  line-height: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
}

.bigTotal {
  font-size: 12px;
  font-weight: bold;
  padding-right: 20px;
}

.bigTitle img {
  width: 20px;
  height: 20px;
  margin: 0 8px;
}

.live {
  font-size: 12px;
  background: linear-gradient(90deg, #F8433A, #FF7869);
  color: #fff;
  padding: 3px 8px;
  border-radius: 5px 0 5px 0;
  margin-right: 5px;
}


.flex-grow {
  flex-grow: 1;
}

.xx {
  overflow-y: scroll;
  height: 450px;
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.inline-block {
  display: inline-block;
}

.thumb_images {
  width: 100%;
  height: 175px;
  border-radius: 5px;
}

.border-tags {
  border: 1px solid #c18958;
}

.text-tags {
  color: #c18958;
}

.text-6581A0 {
  color: #6581a0;
}

.bg-F9F9F9 {
  background: #f9f9f9;
  height: 50px;
}

.text-6F8199 {
  color: #6f8199;
}

.truncate {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.border-sub {
  border: 1px solid #cccccc;
}

.year-tag {
  background-color: #f0f3f7;
  color: #233650;
  width: 106px;
  height: 42px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
}

.year-tag.active {
  background-color: #3078ff;
  color: #fff;
  position: relative;
}

.year-tag.active::after {
  content: "";
  display: block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid #3078ff;
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -7px;
}
</style>
